module.exports = __webpack_public_path__ + "static/img/community02.f088798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community02.jpg
// module id = eBI8
// module chunks = 0